<style scoped>
	#login{
		position: absolute;
		top: 50%;
		left: 50%;
		width: 460px;
		margin: -300px 0 0 -230px;
		text-align: center;
		z-index: 3;
	}
	#login-form{
		background-color: #007fd5;
		margin-top: 70px;
	}
	.tabs{
		color:#fff;
		width: 100%;
		height: 68px;
		text-align: center;
		font-size: 20px;
		background-color: #0094f3;
	}
	.tabs-item{
		width: 40%;
		height: 68px;
		line-height: 68px;
		float: left;
		cursor: pointer;
		color: #abd6ff;
	    -webkit-transition: all .75s;
	    transition: all .75s;
	}
	.tabs-active{
		width: 60%;
		color: #fff;
		text-align: left;
		padding-left: 30px;
		background-color: #007fd5;
	}
	.ipt-group{
		text-align: left;
		height: 68px;
		font-size: 17px;
		border-top: 1px solid #1288d8;
	}
	.ipt-group label{
		text-align: center;
		width: 100px;
		color: #dae4ed;
		line-height: 68px;
	}
	.ipt-group input{
		width: 350px;
		height: 42px;
		border:none;
		outline: none;
		color: #dae4ed;
		background-color: transparent;
	}
	.forget{
		height: 68px;
		line-height: 68px;
		color: #dae4ed;
		padding-left: 30px;
		text-align: left;
		border-top: 1px solid #1288d8;
	}
	.submit{
		height: 65px;
	}
	.ipt-btn button{
		height: 60%;
		font-size: 16px;
		color: #007fd5;
		background-color: #fff;
		border:1px solid #007fd5;
		cursor: pointer;
	    -webkit-transition: all .75s;
	    transition: all .75s;
	}
	.submit button{
		width: 130px;
		height: 40px;
		font-size: 18px;
		color: #007fd5;
		background-color: #fff;
		border:1px solid #007fd5;
		border-radius: 30px;
		cursor: pointer;
	    -webkit-transition: all .75s;
	    transition: all .75s;
	}
	.submit button:hover{
		color: #fff;
		background-color: #0094f3;
	}
	::-webkit-input-placeholder { /* WebKit browsers */
	    color:    #abd6ff;
	}
	:-moz-placeholder { /* Mozilla Firefox 4 to 18 */
	    color:    #abd6ff;
	}
	::-moz-placeholder { /* Mozilla Firefox 19+ */
	    color:    #abd6ff;
	}
	:-ms-input-placeholder { /* Internet Explorer 10+ */
	    color:    #abd6ff;
	}
	#footer{
		position: absolute;
		width: 100%;
		left: 0;
		bottom: 10px;
		color: #656974;
		text-align: center;
		z-index: 1;
	}
	/* 必需 */
	.expand-transition {
	  transition: all .3s ease;
	  overflow: hidden;
	}

	/* .expand-enter 定义进入的开始状态 */
	/* .expand-leave 定义离开的结束状态 */
	.expand-enter, .expand-leave {
	  height: 0;
	  opacity: .8;
	}
</style>
<template>
	<div class="layout">
		<div id="login">
			<img src="../img/logo.png"/>
			<div id="login-form">
				<div class="tabs">
					<div class="tabs-item" :class="tab==1?'tabs-active' : ''" @click="changeTab(1)">登录</div>
					<div class="tabs-item" :class="tab==2?'tabs-active' : ''" @click="changeTab(2)">修改密码</div>
				</div>

				<div class="input-layout" v-show="tab==1" transition="expand">
					<div class="ipt-group">
						<label>账户</label>
						<input type="text" placeholder="请输入登录账户" v-model="info.phone" @keyup.enter="submit" maxlength="11">
					</div>
					<div class="ipt-group">
						<label>密码</label>
						<input type="password" placeholder="请输入登录密码" v-model="info.password" @keyup.enter="submit">
					</div>
					
					<div class="forget">
						<label><input type="checkbox" v-model="info.remember_on">&nbsp;记住登录状态,下次自动登录</label>
					</div>
					<div class="submit">
						<button type="button" @click="submit">{{loginTxt}}</button>
					</div>
				</div>

				<div class="input-layout" v-show="tab==2" transition="expand">
					<div class="ipt-group">
						<label>账户名</label>
						<input type="text" placeholder="请输入账户名" v-model="editInfo.phone" id="iptPhone" @keyup.enter="getCode" maxlength="11">
					</div>
					<div class="ipt-group ipt-btn">
						<label>验证码</label>
						<input type="text" placeholder="请输入手机验证码" v-model="editInfo.code" class="w216"  @keyup.enter="confirm">
						<button class="btn  h60b" type="button" @click="getCode" id="btnCode">{{codeTxt}}</button>
					</div>
					<div class="ipt-group">
						<label>新密码</label>
						<input type="password" placeholder="请输入新密码" v-model="editInfo.password" @keyup.enter="confirm">
					</div>
					<div class="submit">
						<button type="button" @click="confirm">{{loginTxt}}</button>
					</div>
				</div>

			</div>
		</div>
		<div id="footer">
			Copyright © 2016 路易师傅汽车信息科技 版权所有<br/>Powered by @Luyishifu.com
		</div>
	</div>
</template>
<script>
	var Http = require('../utils/HttpHelper.js');
	var Comm = require('../utils/Common.js');
	var logver = [
		[
			'phone',Comm.isNull,'请输入登录账户'
		],
		[
			'phone',Comm.isPhone,'请输入有效的手机号码'
		],
		[
			'password',Comm.isNull,'请输入登录密码'
		]
	];
	var editver = [
		[
			'phone',Comm.isNull,'请输入登录账户'
		],
		[
			'phone',Comm.isPhone,'请输入有效的手机号码'
		],
		[
			'code',Comm.isNull,'请输入验证码'
		],
		[
			'password',Comm.isNull,'请输入新密码'
		],
		[
			'password',Comm.isPassword,'请输入6-16位的密码'
		]
	];
	/**
	 * 设置获取验证码 文字
	 * @param {[type]} vm vue对象
	 * @param {[type]} s  秒数
	 */
	var setCodeTxt = function(vm,s) {
		 if (s > 0) {
            var txt = s + "秒后可获取";
            vm.codeTxt = txt;
        } else {
            vm.codeTxt = "获取验证码";
        }
	};
	/**
	 * 设置按钮样式
	 * @param {[type]} vm [description]
	 * @param {[type]}    [description]
	 */
	var setBtnStyle = function(vm) {
		if(vm.flag) {
			vm.btnCode.css({
				"backgroundColor": "#fff",
				"color": "#007fd5",
				"cursor": "pointer"
			});
		} else {
			vm.btnCode.css({
				"backgroundColor": "#cfcfcf",
				"color": "#999",
				"cursor": "not-allowed"
			});
		}
	};
	module.exports= {
		data : function(){
			return {
				tab : 1,
				info : {
					phone : '',
					password : '',
					remember_on: false//记住密码
				},
				editInfo: {
					phone : '',
					code: '',
					password : '',
					password_confirmation: ''
				},
				isLogin : false,//标识是否在登录状态
				loginTxt : '登 录',//登录按钮的文本
				codeTxt: '获取验证码',//获取验证码按钮文字
				flag: false,//用于标识获取验证码
				btnCode: {},//验证码按钮	
				codeBtn: {},//验证码按钮对象		
				isClick: false,//标识是否点击了获取验证码	
				/**
				* 存储账户是否记住密码状态
				*/
				saveAccount : function(){
					if(this.info.remember_on){//记住秘密，存储本地标识
						localStorage.setItem('remember_on',this.info.remember_on);
					}					
				},
				/**
				* 获取是否记住密码
				*/
				readAccount : function(){				
					if(localStorage.getItem('remember_on') == "true") {
						return true;
					} else {
						return false;
					}
				},
				/**
				 * 存储最近一次登录账户
				 */
				saveLastAccount: function() {
					localStorage.setItem('lastLogin',this.info.phone);
				}
			}
		},
		ready: function() {
			var lastLogin = localStorage.getItem('lastLogin');
			if(lastLogin) {
				this.info.phone = lastLogin;
			}
			var self = this;
			this.btnCode = $("#btnCode");
			setBtnStyle(this);//设置按钮样式
			this.codeBtn = document.getElementById("btnCode");
			this.codeBtn.disabled = true;//设置按钮不可用
			this.$watch("editInfo.phone", function(e) {
				if(Comm.isPhone(e) && !self.isClick) {//如果没有点击，样式根据手机号格式是否正确
					self.flag = true;
					self.codeBtn.disabled = false;
				} else {
					self.flag = false;
					self.codeBtn.disabled = true;//设置按钮可用
				}
				setBtnStyle(this);//设置按钮样式
			});
			this.$watch("isClick", function(e){//监听获取验证码是否点击了
			});
			this.$watch("tab", function(e) {
				if(e == 1) {
					self.loginTxt = "登 录";
				} else {
					self.loginTxt = "确认修改";
				}
			});			
		},
		methods : {
			changeTab : function(index){
				this.tab = index;
			},
			submit : function(){
				if(Comm.validate(logver,this.info)) {//表单验证
					if(!this.isLogin){
						var self = this;
						this.isLogin = true;
						this.loginTxt = '登录中...';
						Http.login.create({
							data : this.info,
							succ : function(){			
								self.isLogin = false;
								self.loginTxt = "登 录";							
								//派发事件，事件沿着父链冒泡；
								self.$dispatch('login',true);
								self.saveAccount();//自动登录的记录
								self.saveLastAccount();//记住最近一次登录名
							},
							err : function(msg){
								self.isLogin = false;
								self.loginTxt = "登 录";
								Comm.tipDialog(msg,1500,"error");
							} 
						});
					}
				}				
			},
			confirm: function() {
				this.editInfo.password_confirmation = this.editInfo.password;
				if(Comm.validate(editver,this.editInfo)) {//表单验证
					if(!this.isLogin) {
						var self = this;
						this.isLogin = true;
						this.loginTxt = '修改中...';
						Http['smsforget'].create({
							data: self.editInfo,
							succ: function(rs) {
								self.isLogin = false;
								self.loginTxt = "确认修改";		
								Comm.tipDialog("修改成功",1500,"success");
								location.reload();
							},
							err: function(msg) {
								self.isLogin = false;
								self.loginTxt = "确认修改";
								Comm.tipDialog(msg,1500,"error");
							}
						})
					}
				}
			},
			/**
			 * 获取验证码
			 */
			getCode: function() {
				var self = this;
				this.flag = false;
				this.codeBtn.disabled = true;				
				if(Comm.isPhone(self.editInfo.phone)){
					setBtnStyle(self);//设置按钮样式
					Http['smscode'].create({
						data: {phone: self.editInfo.phone},
						succ: function(rs) {
							//倒计时 60秒
							self.isClick = true;
							var time = 60;
							setCodeTxt(self,time);
							var inter = setInterval(function() {
			                    time -= 1;
			                    if (time <= 0) {
			                        clearInterval(inter);
			                        if(Comm.isPhone(self.editInfo.phone)) {//点击获取验证码60秒后判断账户是否还是手机格式
			                        	self.flag = true;
			                        	self.codeBtn.disabled = false;//设置按钮可用
			                        }	                       
			                        self.isClick = false;
			                        setBtnStyle(self);//设置按钮样式
			                    }
			                    setCodeTxt(self,time);
			                }, 1000);	                
						},
						err: function(msg) {
							Comm.tipDialog(msg,1500,"error");							
                        	self.flag = true;
                        	self.codeBtn.disabled = false;//设置按钮可用                 
	                        setBtnStyle(self);//设置按钮样式
						}
					});					
				} else {
					Comm.tipDialog("请输入有效的手机号码",1500,"error");
				}
			}	
		}
	}
</script>


/** WEBPACK FOOTER **
 ** Login.vue?66402699
 **/